module.exports = __webpack_public_path__ + "assets/img/teacher_top3.0908c677.png";